import { axiosInstance } from "./";

const getApplicantReportList = async (data) => {
  let queryParams = data?.params;
  return await axiosInstance.get(`/events/${data?.id}/files`, { queryParams });
};
const postApplicantReports = async (data) => {
  return await axiosInstance.post(
    `/events/${data?.event_id}/files`,
    data?.data
  );
};
const deleteApplicantReport = async (data) => {
  return await axiosInstance.delete(
    `/events/${data?.event_id}/files/${data?.report_id}`
  );
};
const getApplicantDetail = async ({ event_id, id }) =>
  await axiosInstance.get(`/events/${event_id}/logistics_issues/${id}`);

const exportApplicantSheet = async (obj) => {
  return await axiosInstance.get(`/events/${obj?.event_id}/files/${obj.id}`);
};
const exportAllApplicantReportFiles = async (obj) =>
  await axiosInstance.get(`/events/${obj?.event_id}/files/download_all`);

export {
  getApplicantReportList,
  postApplicantReports,
  deleteApplicantReport,
  getApplicantDetail,
  exportApplicantSheet,
  exportAllApplicantReportFiles,
};
